var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("404找不到這一頁")])
}
var staticRenderFns = []

export { render, staticRenderFns }